import React from 'react';
import { cn } from '@/lib/utils';

function BodyTypography({ children, className, ...props }: React.ComponentProps<'p'>) {
    return (
        <p className={cn('text-foreground text-base', className)} {...props}>
            {children}
        </p>
    );
}

export default BodyTypography;
